module.exports = __webpack_public_path__ + "images/dingtalk/404-5cecb8fe89392880cb952a785bd3e600.png";